// extracted by mini-css-extract-plugin
module.exports = {"readOnly":"style__readOnly__V4pdX"};